module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/industries.json
// module id = 404
// module chunks = 102343262989380